<template>
    <b-card no-body class="overflow-hidden" style="max-width: 540px;">
        <b-row>
            <b-col>
                <b-img 
                    class="image1"
                    :src="imgSrc"
                />
            </b-col>
        </b-row>
        <b-row class="my-3 mx-0">
            <b-col>
                <div class="h5 mb-0 text-success">
                    <strong>{{businessName}}</strong>
                </div>
                <div class="text-muted d-flex flex-row">
                    <Star 
                        :rating="averageRating"
                        :readOnly=true
                    />
                    <div class="mx-2">{{numberOfRatings}} reviews</div>
                </div>
                <div>
                    {{categories}}
                </div>
                <div>
                    {{subCity}}
                </div>
                <div style="color: #ff8c00;">
                    <b-icon icon="brightness-high-fill" /> {{newness}}
                </div>
            </b-col>
        </b-row>
    </b-card>
</template>

<style scoped>
.image1 {
    width: 100%;
    height: 220px;
    object-fit: cover;
}
</style>

<script>
import Star from '../place/Star'

export default {
    components: {
        Star
    },
    props: {
        imgSrc: {
            type: String
        },
        businessName: {
            type: String
        },
        averageRating: {
            type: Number
        },
        numberOfRatings: {
            type: Number
        },
        categories: {
            type: String
        },
        subCity: {
            type: String
        },
        newness: {
            type: String
        }
    },
    data() {
        return {
            
        }
    },
    methods: {

    },
    mounted() {

    }
}
</script>